import {
    whiteColor,
    primaryColor,
    secondaryColor,
    infoColor,
    warningColor,
    roseColor
} from "assets/jss/material-dashboard-react.js";


const drawerWidth = 240;
const styles = theme => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        justifyContent: 'space-between',
        ...theme.mixins.toolbar
    },
    muiToolbarRegular: {
        minHeight: 50
    },
    muiToolbarDense: {
        minHeight: 60
    },
    toolbarGutters: {
        padding: 0
    },

    topBar: {
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: whiteColor,
        color: secondaryColor[1],
        padding: '0 10px 0 10px'
    },
    topBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },

    bottomBar: {
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: whiteColor,
        color: secondaryColor[1],
        top: 'auto',
        bottom: 0,
        alignItems: 'center'
    },

    bottomNavigation: {
        backgroundColor: 'transparent',
        height: 60,
        alignItems: 'flex-start'

    },

    bottomNavigationActionRoot: {
        minWidth: 90,
        [theme.breakpoints.down('xs')]: {
            minWidth: 70,
            padding: '6px 10px 8px'
        },
    },
    buttonNavigationAction: {
        color: 'inherit'
    },
    buttonNavigationsSelected: {
        color: `${infoColor[0]} !important`
    },

    actionLabel: {
        lineHeight: '0.7rem !important',
        fontSize: '0.75rem !important'
    },

    menuButton: {
        marginLeft: 12,
        marginRight: 12,

    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {


    },
    title1: {
        color: "white"
    },
    avatarsmall: {
        width: theme.spacing(3.5),
        height: theme.spacing(3.5),
    },
    logoDiv: {
        position: "absolute",
        height: '50px',
        top: '0'
    },
    imageStyle: {
        height: "inherit"
    },
    iconButton: {
        color: primaryColor[0],
        padding: 5
    },
    iconbqbnseButton: {
        color: warningColor[0],
        padding: 5
    },
    iconnNotificationsButton: {
        color: primaryColor[0],
        padding: 5
    },
    iconDialButton: {
        color: roseColor[0],
        padding: 5
    },
    muiIconRoot: {
        width: '2.5em !important'
    },


    iconRoot: {
        width: '1.2em !important',
        height: '1em !important',
    },
    svgIconRoot: {
        width: '1.2em !important',
        height: '1.2em !important',
    },
    smallAvatar: {
        width: theme.spacing(2.5),
        height: theme.spacing(2.5),
        
    },

    userNameText: {
        fontWeight: 'bold',
        maxWidth: '10rem',
        lineHeight: 1,
        marginRight: 2,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        // height: '3em',
        '-webkit-line-clamp': '1',
        '-webkit-box-orient': 'vertical',
        [theme.breakpoints.down('xs')]: {
            maxWidth: '5rem',
        },
    }

});

export default styles;
